module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalplaysolo",
    attrs: {
      "id": "modalplaysolo",
      "title": "Jouer en solo",
      "hide-footer": true
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm mb-3 bt-white rounded",
    attrs: {
      "title": "Jeu individuel en mode plateau",
      "img-src": require('@/assets/images/play-singleplayer.jpg'),
      "img-alt": "Jeu multijoueurs",
      "img-top": ""
    }
  }, [_c('b-card-text', {
    staticClass: "text-left"
  }, [_vm._v("\n      Piochez un mot et trouvez la meilleure combinaison de cartes pour faire deviner les autres joueurs. "), _c('br'), _vm._v("\n      Et à votre tour, essayez de deviner les mots des plateaux proposés par les autres joueurs.\n    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBoard()
      }
    }
  }, [_vm._v("Créer un plateau "), _c('font-awesome-icon', {
    attrs: {
      "icon": "chess-board"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.displayBoardList()
      }
    }
  }, [_vm._v("Deviner des plateaux "), _c('font-awesome-icon', {
    attrs: {
      "icon": "question"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491b85df","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-play-solo.vue
// module id = OKI/
// module chunks = 1